/** The formation's geometry and its two motions (docs/spec/02 §3): the slide while filling, then the breath. */

import { cos, TAU } from './math';
import { FORMATION } from './tuning';
import type { Formation, GameState } from './types';

export function newFormation(): Formation {
  return { t: 0, sway: 0, spread: 1, settled: false, settledT: 0 };
}

export function slotX(f: Formation, col: number): number {
  return FORMATION.cx + (col - 4.5) * FORMATION.cell * f.spread + f.sway;
}

/** Row -1 is the place above a Monarch where its captive rides. */
export function slotY(f: Formation, row: number): number {
  return FORMATION.top + row * FORMATION.cell * (1 + (f.spread - 1) / 2);
}

export function updateFormation(s: GameState): void {
  const f = s.formation;
  f.t++;
  if (!f.settled) {
    // A triangle wave that starts in the middle.
    const phase = (f.t / FORMATION.swayPeriod + 0.25) % 1;
    f.sway = FORMATION.swayAmp * (4 * Math.abs(phase - 0.5) - 1);
    return;
  }
  f.settledT++;
  if (Math.abs(f.sway) <= 0.5) f.sway = 0;
  else f.sway -= f.sway > 0 ? 0.5 : -0.5;
  f.spread = 1 + FORMATION.breatheAmp * (0.5 - 0.5 * cos((TAU * f.settledT) / FORMATION.breathePeriod));
}

/** Which of the two wing frames the whole formation shows. */
export function wingFrame(tick: number): number {
  return Math.floor(tick / FORMATION.beat) % 2;
}
